import { render } from "./consumedetail.vue?vue&type=template&id=caeb5a96"
import script from "./consumedetail.vue?vue&type=script&lang=js"
export * from "./consumedetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__